module.exports = __webpack_public_path__ + "img/eoy-giving-donate-2.5a75eddc.jpg";